export enum FeatureFlagsOptions {
  FF_SAPRON_OLD_BANNER_SPOT = 'ff_sapron_old_banner_spot',
  FF_SAPRON_REDIRECT_OWNER = 'ff_sapron_front_enable_wallet_redirect',
  FF_SAPRON_OWNER_DROPDOWN = 'ff_sapron_owner_dropdown',
  FF_SAPRON_DISABLE_BANK_ACCOUNT = 'ff_sapron_disable_bank_account',
  FF_SAPRON_ENABLE_OWNER_EDITION = 'ff_sapron_front_enable_owner_edition',
  FF_SAPRON_ENABLE_HOST_EDITION = 'ff_sapron_front_enable_host_edition',
  FF_SAPRON_ENABLE_HOST_BANK_ACCOUNT_EDITION = 'ff_sapron_front_enable_host_bank_account_edition',
  FF_SAPRON_ENABLE_OWNER_PERSPECTIVE = 'ff_sapron_enable_owner_perspective',
  FF_SAPRON_FRONT_ENABLE_PAGE_STATUS_ANUNCIO = 'ff_sapron_front_enable_page_status_anuncio',
  FF_SAPRON_ENABLE_CLOSING_V3 = 'ff_sapron_enable_closing_v3',
  FF_SAPRON_V2_BLOCKING_PROPERTY = 'ff_sapron_new_endpoint_blocking_property',
  FF_SAPRON_VISIBLE_LINK_SCORE = 'ff_sapron_visible_link_score_host',
  FF_SAPRON_NEW_EXPENSE_PAGE = 'ff_sapron_new_expense_page',
  FF_SAPRON_NEW_REFUND_PAGE = 'ff_sapron_new_refund_page',
  FF_SAPRON_POPUP_EXPENSE_PENDING = 'ff_sapron_popup_expense_pending',
}
